import React from 'react';
import styles from './DocList.module.scss';
import Attachment from '../../../NewAttachment/NewAttachment';
import useDeleteAttachments from '../../api/mutation/useDeleteAttachments';
import useGetAttachmentUrl from '../../hooks/useGetAttachmentUrl';

const DocList = ({ transportId, data = [] }) => {
  const { mutateAsync: deleteAttachment } = useDeleteAttachments();
  const getAttachmentUrl = useGetAttachmentUrl();

  return (
    <ul className={styles.root}>
      {data.map((attach) => (
        <li key={attach.id}>
          <Attachment
            className={styles.attachment}
            attachments={data}
            attachment={attach}
            getAttachmentUrl={getAttachmentUrl({
              transportId,
            })}
            onDeleteAttachment={(attach) =>
              deleteAttachment({ transportId, fileName: attach.fileName })
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default DocList;
